/*
 * @Author: your name
 * @Date: 2019-06-17 14:58:11
 * @LastEditTime: 2020-02-26 13:54:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\POISearch\UCPOISearchJs.js
 */
import { POISearchFilter, POISearchFilterType } from "../model/POISearch.js";

/**
 * ucpoi搜索模块事件定义
 */
export const UCPOISearchEvent=
{   
    /**
     * 分页uc-查询结果改变
     */
    UCPOIResultPaging_searchResultChange:"event_UCPOIResultPaging_searchResultChange",

    //分页uc-单击poi
    UCPOIResultPaging_poiItemClick:"event_UCPOIResultPaging_poiItemClick",

    //分页uc-poi项鼠标浮上
    UCPOIResultPaging_poiItemMouseOver:"event_UCPOIResultPaging_poiItemMouseOver",

    
    //分页uc-poi项鼠标离开
    UCPOIResultPaging_poiItemMouseOut:"event_UCPOIResultPaging_poiItemMouseOut",
    
    //建议词uc-poi项单击
    UCPOISuggestKey_poiItemClick:"event_UCPOISuggestKey_poiItemClick",

    //模糊查询uc-poi搜索按钮单击
    UCPOIFuzzyKey_poiSearchClick:"event_UCPOIFuzzyKey_poiSearchClick",

    /**
     * 模糊查询uc-poi搜索框获得焦点
     */
    UCPOIFuzzyKey_inputFocusClick:"UCPOIFuzzyKey_inputFocusClick",
    
}


export class UCPOIResultParams
{   
    constructor()
    {
        this.fuzzyKey=null;

        this.suggestPoi=null;
        
        this.centerPoi=null;

        this.commonPoi=null;
        
        this.curMap=null;
    }

    getPOIFilter()
    {   
        let filter=POISearchFilter.createFilterFromMap(this.curMap);
        
        if(this.commonPoi)
        {
            filter.filterType=POISearchFilterType.national_common;
            filter.keyWord=this.commonPoi.name;
            if(this.commonPoi.gbCode)
            {
                filter.specifyAdminCode=this.commonPoi.gbCode;
            }
            else
            {
                filter.specifyAdminCode=null;
            }
            
        }
        

        if(this.suggestPoi)
        {   
            filter.filterType=POISearchFilterType.national_common_suggest;
            filter.keyWord=this.suggestPoi.name;
            
            filter.specifyAdminCode=null;
        }

        if(this.centerPoi)
        {
            filter.filterType=POISearchFilterType.national_common_center;
            filter.keyWord=this.centerPoi.name;
            filter.centerPointX=this.centerPoi.x;
            filter.centerPointY=this.centerPoi.y;
            filter.radiusDistance=5000;
            
            filter.specifyAdminCode=null;
        }

        if(!filter.filterType)
        {
            filter.filterType = POISearchFilterType.national_common;
        }
        

        if(this.fuzzyKey)
        {
            filter.keyWord=this.fuzzyKey;
        }

        
        return filter;
    }

}

